import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetModelDetailNewsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {HTTPNewsRepository} deps.repository
   * @param {Object} deps.log
   */
  constructor({repository, log}) {
    super({repository, log})

    this._repository = repository
    this._log = log
    this._fallbackResponse = {}
  }

  /**
   * @return {Promise<Object, Error>} returns array with feed arrays of news items
   * @property {Array} home news items
   */
  execute = async params => {
    return this._repository
      .getModelDetailNews(params)
      .then(response => response.toJSON())
      .catch(e => {
        this._log(`GetModelDetailNewsUseCase failed with error: ${e}`)
        return this._fallbackResponse
      })
  }
}
